import React from 'react';
import {
  Link,
} from "react-router-dom";

import styles from './ProductBannerCard.module.scss';

import Media from "./Media";

const ProductBannerCard = ({ image, title, points, id, buttonText, buttonColour, buttonTextColour, textColour }) => {
  return (
    <Link to={`/rewards/${encodeURI(id)}`} key={id} className={styles.productBanner}>
      <Media image={image}/>
      <div>
        <h3 style={{ color: textColour ? `#${textColour}` : undefined}}>{ title }</h3>
        { +points === 0 ? <span style={{ color: textColour ?  `#${textColour}` : undefined}}>Free</span> : <span style={{ color: textColour ?  `#${textColour}` : undefined}}>{points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} points</span> }
        <button style={{ backgroundColor: buttonColour ? `#${buttonColour}` : undefined}}>
          <span style={{ color: buttonTextColour ? `#${buttonTextColour}` : undefined}}>{ buttonText ? buttonText : 'View Offer' }</span>
        </button>
      </div>
    </Link>
  )
}

export default ProductBannerCard;
